import { createSlice, PayloadAction} from "@reduxjs/toolkit";
import {RequestError} from "../Entity/RequestError";
import {AppThunk} from "../../app/store";
import {CustomerOrders} from "../Entity/Order";
import {getCustomerOrdersRep} from "../Repository/OrderRepository";

interface OrderState {
  isRequesting: boolean,
  isRequestSuccess: boolean,
  isRequestFailed: boolean,
  isRequestingDelete: boolean,
  error: RequestError | null,
  orders: CustomerOrders[]|null,
}

const OrderInitialState: OrderState = {
  isRequesting: false,
  isRequestSuccess: false,
  isRequestFailed: false,
  isRequestingDelete: false,
  orders: null,
  error: null,
}

function startRequest(state: OrderState) {
  state.isRequesting = true;
  state.isRequestingDelete = false;
  state.isRequestFailed = false;
  state.orders = null;
}

function registerFailed(state: OrderState, action: PayloadAction<any>) {
  state.isRequesting = false;
  state.isRequestSuccess = false;
  state.isRequestFailed = true;
  state.error = action.payload;
}

function registerSuccess(state: OrderState, action: PayloadAction<any>) {
  state.isRequesting = false;
  state.isRequestSuccess = true;
  state.isRequestFailed = false;
  state.error = null;
  state.orders = action.payload["hydra:member"] as CustomerOrders[];
}

const orderSlice = createSlice({
    name: 'orders',
    initialState: OrderInitialState,
    reducers: {
      OrderStartRequest: startRequest,
      OrderSuccess: registerSuccess,
      OrderFailed: registerFailed,
    }
  }
)

export const {
  OrderStartRequest,
  OrderSuccess,
  OrderFailed
} = orderSlice.actions;

export default orderSlice.reducer;

export const getCustomerOrders = (token : string): AppThunk => async dispatch => {
  try {
    dispatch(OrderStartRequest());
    const newsApiResponse = await getCustomerOrdersRep(token);
    dispatch(OrderSuccess(newsApiResponse));
  } catch (err) {
    dispatch(OrderFailed(err));
  }
}
